import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import IconLabelButton from '../IconLabelButton'
import TextInput from '../TextInput'

import './style.scss'

const TableEditor = ({ onTableChange, tableValues }: any) => {
  const { t } = useTranslation()
  const [tableMatrix, setTableMatrix] = useState(
    tableValues?.length ? tableValues : [['', '']],
  )

  useEffect(() => {
    tableValues?.length && setTableMatrix(tableValues)
  }, [tableValues])

  useEffect(() => {
    onTableChange(tableMatrix)
  }, [tableMatrix])

  const onRowCellChange = (value: any, rowIndex: any, rowCellindex: any) => {
    let temp = [...tableMatrix]
    temp[rowIndex][rowCellindex] = value
    setTableMatrix(temp)
  }

  const addNewRow = () => {
    let temp = [...tableMatrix]
    temp.push(['', ''])
    setTableMatrix(temp)
  }

  const handleEnter = (event: any) => {
    if (event.key === 'Enter') {
      event.preventDefault()
      return
    }
  }

  const insertNewRow = (targetRowIndex: any) => {
    let temp = [...tableMatrix]
    temp.splice(targetRowIndex + 1, 0, ['', ''])
    setTableMatrix(temp)
  }

  const removeRow = (targetRowIndex: any) => {
    let temp = [...tableMatrix]
    temp.splice(targetRowIndex, 1)
    setTableMatrix(temp)
  }

  return (
    <div>
      <div className="flex-container no-justify-flex">
        <div className="table-editor-wrapper">
          <div className="table-editor-header-row">
            {['Keyword', 'Score'].map(headerName => (
              <div key={headerName} className="table-header-disabled-cell">
                {headerName}
              </div>
            ))}
          </div>
          <div className="table-editor-body-wrapper">
            {tableMatrix &&
              tableMatrix.map((tableRow: any, rowIndex: any) => (
                <div key={rowIndex} className="table-editor-row">
                  {tableRow.map((tableCell: any, rowCellIndex: any) => (
                    <div className="table-row-cell-wrapper">
                      <TextInput
                        useTextArea
                        id={`row${rowIndex.toString()}${rowCellIndex.toString()}`}
                        key={`row${rowIndex.toString()}${rowCellIndex.toString()}`}
                        value={tableCell}
                        inputChange={(event: any) =>
                          onRowCellChange(
                            event.target.value,
                            rowIndex,
                            rowCellIndex,
                          )
                        }
                        // onInputClick={onInputClick}
                        // max={2}
                        min={2}
                        placeholder={t('Type text here')}
                        onKeyPress={handleEnter}
                      />
                    </div>
                  ))}
                  <div className="table-editor-row-actions">
                    <button
                      onClick={() => {
                        insertNewRow(rowIndex)
                      }}
                      className="toolbar-btn"
                      title="Insert row below"
                    >
                      <i className="icon-add toolbar-icon" />
                    </button>
                    {tableMatrix.length > 1 && (
                      <button
                        onClick={() => {
                          removeRow(rowIndex)
                        }}
                        className="toolbar-btn"
                        title="Remove row"
                      >
                        <i className="icon-delete toolbar-icon" />
                      </button>
                    )}
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
      <div className="quarter-clearfix" />
      <IconLabelButton
        showIcon
        iconClass="icon-add"
        buttonLabel={t('Add row')}
        onClick={addNewRow}
      />
    </div>
  )
}

export default TableEditor
